module.exports = __webpack_public_path__ + "img/LOGO_LULUU.a36f9466.png";